module.exports = __webpack_public_path__ + "static/img/1_4.d33669fc.jpg";